import script from "./SimCardDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimCardDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SimCardDetail.vue?vue&type=style&index=0&id=328fbdce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328fbdce"]])

export default __exports__